/* eslint-disable no-unused-expressions */
import moment from 'moment'

export const sharedReportingMixin = {
  data () {
    return {
      badWords: []
    }
  },
  computed: {
    user () {
      return this.$store?.getters?.getUser || {}
    },
    employeeRoles () {
      return this.$store?.getters?.getEmployeeRoles || {}
    },
    activityTypes () {
      return this.$store?.getters?.getActivityTypes || []
    }
  },
  methods: {
    async getBadWords () {
      try {
        const response = await this.axios.get('/api/bad_words', {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        })
        this.badWords = response.data
        if (this.$store?._mutations?.SET_BAD_WORDS) {
          this.$store.commit('SET_BAD_WORDS', response.data)
        }
        return response.data
      } catch (error) {
        console.error('Failed to fetch bad words:', error)
        this.$store?.dispatch('setError', { errorMsg: error.message })
        return []
      }
    },
    reportHoursToTime (value) {
      if (value < 0 || value > 23.5) return ''
      const duration = moment.duration(value, 'hours')
      const hours = duration.hours()
      const minutes = duration.minutes()
      const formattedHours = hours.toString().padStart(2, '0')
      const formattedMinutes = minutes.toString().padStart(2, '0')
      return `${formattedHours}:${formattedMinutes}`
    },
    canReport (projectName) {
      const excludedProjects = ['DC Vacations', 'DC Sick-Leave']
      const isFinancier = this.employeeRoles.financier?.val || false

      if (!isFinancier && excludedProjects.includes(projectName)) {
        this.$store?.dispatch('setError', { errorMsg: 'Only Financier role can Save/Update this project report' })
        return false
      }
      return true
    }
  }
}
